import { cx } from '@linaria/core';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/**
 * sometimes ExportService will generate PDFs with invisible text, if a font
 * from a custom @font-face wasn't downloaded in time.
 *
 * this issue can be resolved by mounting an invisible element referencing this
 * font initially, and this helper component servces exactly that purpose.
 *
 * NB: This should be mounted OUTSIDE of DOM nodes that have display: none;
 * before printing.
 */
function ExportServiceFontFixer() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "light"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "light", "italic"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "default"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "default", "italic"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "medium"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "medium", "italic"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "bold"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "bold", "italic"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "extraBold"),
      children: "\xA0"
    }), /*#__PURE__*/jsx("span", {
      className: cx(fontFixerCls, "extraBold", "italic"),
      children: "\xA0"
    })]
  });
}
const fontFixerCls = "_araf1kcl5hk";

export { ExportServiceFontFixer };
import "./util.export-service-font-fixer.linaria.module.css";
//# sourceMappingURL=util.export-service-font-fixer.js.map
